query GetTrainingComplianceSummary($categoryId: ID) {
  trainingComplianceSummary(categoryId: $categoryId) {
    inScope
    notInScope
    complete
    completePercent
    policyAcknowledgedPercent
    newStarters
    overdue
    renewalsDueIn30Days
    withoutPortalAccess
  }
  trainingComplianceModules(categoryId: $categoryId) {
    id
    title
    controlReference
  }
}
